/**
 * core/inflight.ts — per-QueryClient inflight Map.
 *
 * Used by persistence-sentinels to seed paused-mutation sentinels after a
 * `persistQueryClientRestore`. With the manifest-driven SDK rewrite, the
 * new `createMutation` factory does NOT route through this Map — it has
 * its own optimistic + rollback flow inside `onMutate` / `onError`.
 *
 * The Map remains as a load-bearing seam for the persistence-restore boot
 * path: `installPersistenceSentinels(qc)` reads paused mutations from
 * `qc.getMutationCache()` and installs sentinel Promises here. New
 * mutations using `createMutation` don't pause, so the Map stays empty
 * under normal flow. Keeping the seam in place preserves the persistence
 * provider's wiring without forcing a SDKProvider rewrite.
 */

import type { QueryClient } from '@tanstack/react-query';

const inflight = new WeakMap<QueryClient, Map<string, Promise<void>>>();

export function getInflightFor(qc: QueryClient): Map<string, Promise<void>> {
  let m = inflight.get(qc);
  if (m === undefined) {
    m = new Map();
    inflight.set(qc, m);
  }
  return m;
}
